import React from 'react';
import { BookOpen } from 'lucide-react';

export default function BookHero() {
  const scrollToGenerator = () => {
    document.getElementById('book-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          alt="Library with books"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900 via-purple-800 to-purple-900 opacity-85"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="flex justify-center mb-6">
          <BookOpen className="w-16 h-16 text-purple-400 animate-pulse" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          Book Title Generator
        </h1>
        <p className="text-xl text-purple-100 mb-8 max-w-3xl mx-auto">
          Create captivating book titles with our AI-powered generator.
          From gripping novels to insightful non-fiction, craft the perfect title for your masterpiece.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <span className="bg-purple-700/50 px-4 py-2 rounded-full text-white text-sm border border-purple-500/30">
            Fiction Titles
          </span>
          <span className="bg-purple-700/50 px-4 py-2 rounded-full text-white text-sm border border-purple-500/30">
            Non-Fiction
          </span>
          <span className="bg-purple-700/50 px-4 py-2 rounded-full text-white text-sm border border-purple-500/30">
            Genre-Specific
          </span>
        </div>
        <button 
          onClick={scrollToGenerator}
          className="bg-purple-500 text-white text-lg px-8 py-4 rounded-lg hover:bg-purple-600 transition-all cursor-pointer transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 mx-auto"
        >
          <BookOpen className="w-5 h-5" />
          Generate Book Titles
        </button>
        <p className="mt-6 text-sm text-purple-200 bg-purple-800/30 inline-block px-4 py-2 rounded-full mx-auto">
          Trusted by over 10,000+ authors worldwide
        </p>
      </div>
    </div>
  );
}